export default `
// STEP 1 - Enter the cookie name:
const cookieName = '';

function callback(cookieValue) {
    // STEP 2 - Enter custom code here:
    // console.log('cookie value:', cookieValue);
}



/////// PLEASE DO NOT MODIFY ANY CODE BELOW THIS LINE ///////



function getCookie(name) {
    const b = document.cookie.match(\`(^|[^;]+)\\s*\${ name }\\s*=\\s*([^;]+)\`);

    return b ? b.pop() : null;
}

callback(getCookie(cookieName));
`;
